// removed by extract-text-webpack-plugin
module.exports = {"table":"_3f7e","row":"lMAy","spinner":"_9nBw"};


//////////////////
// WEBPACK FOOTER
// ./src/features/MobileServices/MobileServiceForm/AvailableStandardNumbers/AvailableStandardNumbers.scss
// module id = zmz+
// module chunks = 0